





























































import { isEqual } from 'lodash-es'
import axios from '@/common/MyAxios'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import localStorageConfig from '@/common/localstorage-config'
import store, { ILevelInfo, IFieldInfo, IndexingType, StoreType } from '@/store'
import { AxiosResponse } from 'axios'
import { AbstractView } from '@/views/AbstractView'
import * as VCard from 'vuetify/es5/components/VCard'
import * as VTextField from 'vuetify/es5/components/VTextField'
import * as VTextarea from 'vuetify/es5/components/VTextarea'
import * as VBtn from 'vuetify/es5/components/VBtn'
import * as VSelect from 'vuetify/es5/components/VSelect'
import * as VDataTable from 'vuetify/es5/components/VDataTable'
import * as VAlert from 'vuetify/es5/components/VAlert'
import * as VCheckbox from 'vuetify/es5/components/VCheckbox'
import * as VChip from 'vuetify/es5/components/VChip'
import * as VTooltip from 'vuetify/es5/components/VTooltip'
import * as VExpansionPanel from 'vuetify/es5/components/VExpansionPanel'
import * as VAutocomplete from 'vuetify/es5/components/VAutocomplete'

class Option<V> {
  constructor(public text: string, public value: V) {}
}
interface IMatch {
  text: string
  start: number
  end: number
  terms: string[]
}
interface ISnippet {
  id: number
  start: number
  match: IMatch
  snippet: string
  end: number
  tooltip: string
  link: string
  left: string
  right: string
  sort: [
    {
      start: number
      end: number
      text: string
    }
  ]
  tooltips: {
    [fieldId: string]: string
  }
  links: {
    [fieldId: string]: string
  }
  fields: {
    imgurl: string
    [fieldId: string]: any
  }
}
interface ISearchResults {
  queryMetadata: {}
  result: {
    final_query: string
    matches: ISnippet[]
    total: number
  }
}
@Component({
  localStorage: localStorageConfig,
  components: {
    ...VCard,
    ...VChip,
    ...VTooltip,
    ...VDataTable,
    ...VAlert,
    ...VBtn,
    ...VTextField,
    ...VTextarea,
    ...VSelect,
    ...VAutocomplete,
    ...VExpansionPanel
  }
})
export default class KWIC extends AbstractView {
  private tsearch = ''
  private totalResults: number = 0
  private results: ISnippet[] = []
  private filteredResults: ISnippet[] = []
  @Watch('tsearch')
  @Watch('results')
  private customFilter() {
    const search = this.tsearch.toLowerCase().trim()
    if (search === '') this.filteredResults = this.results
    this.filteredResults = this.results.filter(
      item => item.snippet.toLowerCase().indexOf(search) !== -1
    )
  }
  private get fieldEnricher(): (
    field: string,
    value: any,
    obj: ISnippet
  ) => {
    link?: string
    tooltip?: string
  } {
    return new Function('field', 'value', 'obj', this.params.fieldEnricher) as (
      field: string,
      value: any,
      obj: ISnippet
    ) => {
      link?: string
      tooltip?: string
    }
  }
  private get offsetDataConverter(): (snippet: ISnippet) => string {
    return new Function('snippet', this.params.offsetDataConverter) as (snippet: ISnippet) => string
  }
  protected params = {
    level: '',
    endpoint: '',
    fieldEnricher: '',
    offsetDataConverter: '',
    query: '',
    field: [],
    limit: 20,
    offset: 0,
    contextLevel: 'Sentence',
    contextExpandLeft: 0,
    contextExpandRight: 0,
    sortContextLevel: 'Word',
    sortContextDistance: [] as string[],
    sortContextDirection: [] as string[]
  }
  private pagination = {
    page: 1,
    rowsPerPage: this.params.limit
  }
  @Watch('pagination', { deep: true })
  private async search() {
    this.loading = true
    this.params.offset = (this.pagination.page - 1) * this.pagination.rowsPerPage
    this.params.limit = this.pagination.rowsPerPage
    const nq = Object.assign({}, this.$route.query, this.params)
    if (!isEqual(this.$route.query, nq))
      this.$router.push({
        path: '/kwic',
        query: nq
      })
    let cp = this.params
    if (this.params.offsetDataConverter) cp = Object.assign({ offsetData: 'true' }, cp)
    try {
      const response: AxiosResponse<ISearchResults> = await axios.get(
        this.params.endpoint + 'kwic',
        {
          params: cp,
          auth: this.auths[this.params.endpoint]
        }
      )
      this.request =
        response.config.url + '?pretty&' + response.config.paramsSerializer!(response.config.params)
      this.totalResults = response.data.result.total
      this.results = response.data.result.matches
      this.results.forEach((r, idx) => {
        r.match.start = r.match.start - r.start
        r.match.end = r.match.end - r.start
        r.sort.forEach(s => {
          s.start = s.start - r.start
          s.end = s.end - r.start
        })
        r.left = r.snippet.substring(0, r.match.start)
        r.right = r.snippet.substring(r.match.end)
        r.sort
          .sort((a, b) => a.start - b.start)
          .forEach((s, i) => {
            if (s.start < r.match.start)
              r.left =
                r.left.substring(0, s.start) +
                '<span class="' +
                this.styles[i % this.styles.length] +
                '">' +
                r.left.substring(s.start, s.end) +
                '</span>' +
                r.left.substring(s.end)
            else if (s.start > r.match.end)
              r.right =
                r.right.substring(0, s.start - r.match.end) +
                '<span class="' +
                this.styles[i % this.styles.length] +
                '">' +
                r.right.substring(s.start - r.match.end, s.end - r.match.end) +
                '</span>' +
                r.right.substring(s.end - r.match.end)
          })
        r.id = idx
        try {
          ;[r.tooltip, r.link] = this.offsetDataConverter(r)
        } catch (error) {
          console.log(error)
        }
        for (let field of this.params.field) {
          try {
            let res = this.fieldEnricher(field, r.fields[field], r)
            if (res) {
              if (res.link) r.links[field] = res.link
              if (res.tooltip) r.tooltips[field] = res.tooltip
            }
          } catch (error) {
            console.log(error)
          }
        }
      })
    } catch (error) {
      this.results = []
      this.error = error
    } finally {
      this.loading = false
    }
  }
  private level: ILevelInfo = {} as ILevelInfo
  private styles = [
    'red--text',
    'pink--text',
    'purple--text',
    'indigo--text',
    'blue--text',
    'cyan--text',
    'teal--text',
    'light-green--text',
    'lime--text',
    'amber--text',
    'orange--text',
    'brown--text',
    'blue-grey--text'
  ]
  private availableFields: Option<{
    field: string
    fieldInfo: IFieldInfo
  }>[] = []
  private availableQueryableFields: {
    field: string
    fieldInfo: IFieldInfo
  }[] = []
  private sortIndices = '0,-1,1'
  @Watch('sortIndices', { immediate: true })
  private onSortIndicesChanges(): void {
    let re = /(-?\d+)([ADad]?)/g
    let m: RegExpExecArray | null
    this.params.sortContextDistance = []
    this.params.sortContextDirection = []
    while ((m = re.exec(this.sortIndices))) {
      this.params.sortContextDistance.push(m[1])
      this.params.sortContextDirection.push(m[2] !== '' ? m[2] : 'A')
    }
  }
  private sortRules = [
    (v: string) =>
      /^(?:-?\d+[ADad]?\s*,?\s*)*$/.test(v) ||
      'Separate indices by commas. Add D to specify descending sort. E.g. "0D,-1D,1"'
  ]
  private expandOptions = [true, true, false]
  @Watch('$route.query', { immediate: true })
  private onQueryChanged(): void {
    let nq = Object.assign({}, this.$route.query, this.params)
    if (!isEqual(this.$route.query, nq)) {
      Object.assign(this.params, this.$route.query)
      if (!Array.isArray(this.params.field)) this.params.field = [this.params.field]
      if (this.params.endpoint && this.params.query) this.search()
    }
  }
  @Watch('level')
  @Watch('indexInfo')
  private onLevelChanged(): void {
    this.availableFields = []
    this.availableQueryableFields = []
    const fieldsSeen: { [id: string]: boolean } = {}
    if (this.indexInfo) {
      for (let field in store.indexInfos[this.params.endpoint]!.commonFields) {
        let fieldInfo = store.indexInfos[this.params.endpoint]!.commonFields[field]
        let fd = {
          field,
          fieldInfo
        }
        if (fieldInfo.storedAs != StoreType.NONE)
          this.availableFields.push(new Option(field + ': ' + fieldInfo.description, fd))
        if (fieldInfo.indexedAs != IndexingType.NONE) this.availableQueryableFields.push(fd)
        fieldsSeen[field] = true
      }
      let level = this.indexInfo!.levels.find((l: ILevelInfo) => l.id === this.params.level)!
      for (let field in level.fields)
        if (!fieldsSeen[field]) {
          let fieldInfo = level.fields[field]
          let fd = {
            field,
            fieldInfo
          }
          if (fieldInfo.storedAs != StoreType.NONE)
            this.availableFields.push(new Option(field + ': ' + fieldInfo.description, fd))
          if (fieldInfo.indexedAs != IndexingType.NONE) this.availableQueryableFields.push(fd)
          fieldsSeen[field] = true
        }
      this.params.field = this.params.field.filter(field => fieldsSeen[field])
    }
  }
}
